module.exports = __webpack_public_path__ + "6c013882c2e9af4e1cce019e0c097d8d.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/images/trickstrat/playbookWhite.png
// module id = 1094
// module chunks = 0